import React from "react";

interface Props {
  playlist: Playlist;
}

export default function PlaylistItem(props: Props) {
  return (
    <div className="flex items-center rounded-md">
      <div className="w-16 h-16 bg-gray-200 rounded-md sm:w-20 sm:h-20">
        <img
          src={props.playlist.image?.url}
          className="object-cover object-center w-full h-full rounded-md"
        />
      </div>

      <div className="flex-1 px-3 py-2">
        <p className="text-xs font-bold leading-4">{props.playlist.title}</p>
        <p className="text-xs font-bold leading-4 text-gray-500">
          {props.playlist.songCount} Songs
        </p>
      </div>
    </div>
  );
}
